import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { collectionsClient } from '#pplx_generated/typespec/rest/collections/client.js';
export const listCollectionThreads = async ({ headers = {}, params, reason, throwOnError = false, }) => {
    try {
        const { data, error, response } = await collectionsClient.GET(`/rest/collections/list_collection_threads`, reason, {
            params: {
                query: params,
            },
            headers,
            timeoutMs: getQueryTimeoutMs(),
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: 'Failed to list collection threads',
                cause: error,
                status: response.status ?? 0,
            });
        }
        if (!data || !Array.isArray(data)) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: 'Failed to list collection threads',
                cause: data,
                status: response.status ?? 0,
            });
        }
        return data;
    }
    catch (err) {
        logger.error(err);
        if (throwOnError) {
            throw err;
        }
        return [];
    }
};
//# sourceMappingURL=listCollectionThreads.js.map